<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs4>
        <v-card class="elevation-2">
          <v-toolbar class="elevation-0" dense dark color="teal">
            <v-toolbar-title>Login form</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-text-field
              v-model="login"
              :prepend-icon="mdiAccountCircle"
              name="login"
              label="Login"
              type="text"
              color="teal"
              v-validate="'required'"
              :error-messages="errors.collect('login')"
              data-vv-name="login"
              @keyup.enter="loginMethod({ login, password })"
            />
            <v-text-field
              v-model="password"
              id="password"
              :prepend-icon="mdiLock"
              name="password"
              label="Password"
              type="password"
              color="teal"
              v-validate="'required'"
              :error-messages="errors.collect('password')"
              data-vv-name="password"
              @keyup.enter="loginMethod({ login, password })"
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn
              @click="loginMethod({ login, password })"
              color="teal"
              dark
            >
              Login
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mdiAccountCircle, mdiLock } from "@mdi/js"
export default {
  data() {
    return {
      mdiAccountCircle,
      mdiLock,
      login: '',
      password: '',
      error: {}
    }
  },
  methods: {
    async loginMethod(body) {
      this.$validator.validateAll(body).then(async res => {
        if (res) {
          try {
            const { data } =  await this.$axios.post('/api/login', {
              hash: Buffer.from(body.login + '-frog-' + body.password, 'ascii')
            });
            await this.$store.dispatch('login', data)
            this.$nextTick(() => {
              this.$router.push('/')
            })
          } catch (error) {
            console.log(error)
            const message = error.response.data
            if (/(login)/.test(message)) {
              this.errors.add({
                field: 'login',
                msg: message,
                rule: 'wrong',
              })
            } else {
              this.errors.add({
                field: 'password',
                msg: message,
                rule: 'wrong',
              })
            }
          }
        }
      })
    }
  }
}
</script>